import React from 'react'

import styles from './SeoText.module.scss'
import RichText from '../RichText/RichText'

type Props = {
  text: any
}

const SeoText = ({ text }: Props) => {
  return (
    <section className={styles.seoText}>
      <div className={styles.bar} />
      <RichText content={text} />
    </section>
  )
}

export default SeoText
